<template>
    <section id="contact" class="py-24 bg-gray-50 text-center">
      <div class="max-w-4xl mx-auto px-6">
        <h2 class="text-3xl font-bold text-gray-900">📞 Entre em Contato</h2>
        <p class="text-lg text-gray-600 mt-4">Preencha o formulário e retornaremos o mais rápido possível.</p>
  
        <form @submit.prevent="handleSubmit" class="mt-8 bg-white p-8 rounded-lg shadow-lg text-left max-w-lg mx-auto">
          <!-- Tipo de Contato -->
          <label class="block font-semibold text-gray-700">Motivo do Contato</label>
          <select v-model="form.type" @change="handleTypeChange" class="w-full mt-2 p-3 border rounded-lg">
            <option value="">Selecione...</option>
            <option value="suporte">Suporte</option>
            <option value="lead">Quero Anunciar</option>
          </select>
  
          <!-- Campos básicos -->
          <div class="mt-4">
            <label class="block font-semibold text-gray-700">Nome</label>
            <input v-model="form.name" type="text" class="w-full p-3 border rounded-lg" required />
          </div>
  
          <div class="mt-4">
            <label class="block font-semibold text-gray-700">E-mail</label>
            <input v-model="form.email" type="email" class="w-full p-3 border rounded-lg" required />
          </div>
  
          <div class="mt-4">
            <label class="block font-semibold text-gray-700">Telefone</label>
            <input v-model="form.phone" type="text" class="w-full p-3 border rounded-lg" placeholder="(DDD) 99999-9999"
              @input="validatePhone" required />
            <p v-if="phoneError" class="text-red-600 text-sm mt-1">Número inválido! Use o formato (DDD) + 9 dígitos.</p>
          </div>
  
          <!-- Campos extras para LEAD -->
          <div v-if="form.type === 'lead'">
            <div class="mt-4">
              <label class="block font-semibold text-gray-700">Orçamento Mensal para Marketing</label>
              <select v-model="form.budget" class="w-full mt-2 p-3 border rounded-lg">
                <option value="">Selecione...</option>
                <option value="500-2000">R$ 500 - R$ 2.000</option>
                <option value="2000-5000">R$ 2.000 - R$ 5.000</option>
                <option value="5000-10000">R$ 5.000 - R$ 10.000</option>
                <option value="10000+">Acima de R$ 10.000</option>
              </select>
            </div>
  
            <div class="mt-4">
              <label class="block font-semibold text-gray-700">Objetivo da Campanha</label>
              <textarea v-model="form.goal" rows="3" class="w-full p-3 border rounded-lg"></textarea>
            </div>
          </div>
  
          <!-- Mensagem -->
          <div class="mt-4">
            <label class="block font-semibold text-gray-700">Mensagem</label>
            <textarea v-model="form.message" rows="4" class="w-full p-3 border rounded-lg" required></textarea>
          </div>
  
          <!-- reCAPTCHA -->
         

  
          <!-- Botão de Envio -->
          <button type="submit" class="mt-6 w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition">
            ✉️ Enviar Mensagem
          </button>
        </form>
      </div>
    </section>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  
  const form = ref({
    type: '',
    name: '',
    email: '',
    phone: '',
    budget: '',
    goal: '',
    message: '',
  })
  
  const phoneError = ref(false)
  
  // Validação do telefone brasileiro
  const validatePhone = () => {
    const regex = /^\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/
    phoneError.value = !regex.test(form.value.phone)
  }
  
  // Lógica condicional para exibir campos extras
  const handleTypeChange = () => {
    if (form.value.type === 'suporte') {
      form.value.budget = ''
      form.value.goal = ''
    }
  }
  
  // Validação do reCAPTCHA
  const recaptchaVerified = () => {
    form.value.recaptchaValid = true
  }
  
  const recaptchaExpired = () => {
    form.value.recaptchaValid = false
  }
  
  // Função de envio do formulário
  const handleSubmit = async () => {
    if (phoneError.value || !form.value.recaptchaValid) {
      alert('Corrija os erros antes de enviar!')
      return
    }
  
    try {
      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form.value)
      })
  
      if (response.ok) {
        alert('Mensagem enviada com sucesso!')
        Object.keys(form.value).forEach(key => (form.value[key] = ''))
      } else {
        alert('Erro ao enviar mensagem. Tente novamente.')
      }
    } catch (error) {
      console.error('Erro:', error)
      alert('Falha na comunicação com o servidor.')
    }
  }
  </script>
  